import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PageTitleBasic from '../../../../components/ui/typography/PageTitleBasic'
import SelectPlanCard from '../../../../components/ui/cards/SelectPlanCard'
import RegisterWithTokenCard from '../../../../components/ui/cards/RegisterWithTokenCard'
import ValidateInsTokenForm from './ValidateInsTokenForm'
import withTour from '../../../../components/hocs/withTour'
import applicationConstants from '../../../../utils/constants/application'

class SelectPlanScreen extends Component {
  static propTypes = {
    selectPlan: PropTypes.func.isRequired,
  }
  render() {
    const { selectPlan } = this.props

    return (
      <div className="container">
        <PageTitleBasic
          delay={0.3}
          content="Choose your Yearly Plan"
          subContent="Select your plan or enter your organization's token"
          tourName="choosePlan"
        />
        <div className="max-1000">
          <div className="row" style={{borderRadius: '0.25rem'}} id="choosePlan">
            <div className="col-sm-4 mt-4 p-2" id="select-plan-individual-card">
              <SelectPlanCard
                delay={0.4}
                name="Individual Plan"
                price={applicationConstants.stripe_plan_amounts.INDIVIDUAL}
                features={['360° Career Explorer','360° Education Explorer', 'Scholarship Finder', 'Tuition Calculator', 'Personality Assessment', 'Interest Profiler', 'Curated Feeds']}
                stripe_plan_id={applicationConstants.stripe_plan_ids.INDIVIDUAL}
                selectPlan={selectPlan}
                description="*Single user"
              />
            </div>
            <div
              className="col-sm-4 p-2"
              id="select-plan-parent-card"
            >
              <SelectPlanCard
                delay={0.5}
                name="Family Plan"
                price={applicationConstants.stripe_plan_amounts.PARENT}
                features={['Individual Plan +', 'Up to 3 students','Activity Tracker', 'Manage & Assign Tasks', 'Progress Monitoring', 'Automated Notifications', 'And more!']}
                stripe_plan_id={applicationConstants.stripe_plan_ids.PARENT}
                selectPlan={selectPlan}
                description="*Parent + 3 students"
              />
            </div>
            <div className="col-sm-4 mt-4 p-2" id="register-with-token-card">
              <RegisterWithTokenCard delay={0.7}>
                <ValidateInsTokenForm />
              </RegisterWithTokenCard>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const tourSteps = [
  {
    selector: '#choosePlan',
    content: "New customers should choose either an individual or family plan"
  },
  {
    selector: "#instoken",
    content: "If Steppingblocks is part of your counseling solution, simply enter the provided token for access.",
  }
]

export default withTour('choosePlan', tourSteps)(SelectPlanScreen)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/components/SelectPlanScreen.js